/** 28.09 (владелец: расчёт админа зала «подставляется в отчёт и там закрыт от правки, как
 *  задаток»): оплата в форме отчёта — только для чтения, с подписью, кто вписал. Сервер при
 *  сдаче всё равно возьмёт суммы из расчёта админа (routes/hall-pay.ts). */
export interface HallPayment { cash: number; terminal: number; transfer: number; invoice: number; other: number; change_amount: number; entered_by_name: string }
type Css = Readonly<Record<string, string>>;

export function HallPayRo({ p, prepaid, m }: { p: HallPayment; prepaid: number; m: Css }) {
  const rows: [string, number][] = [["Нал", p.cash], ["Терм", p.terminal], ["Перев", p.transfer], ["ЗДТК", prepaid], ["Р/С", p.invoice], ["Друг.", p.other], ["Сдача", p.change_amount]];
  return (
    <>
      {rows.map(([l, v]) => (
        <div key={l} className={m.payRo} title={l === "ЗДТК" ? "Задаток берётся из брони (ДК)" : "Вписал админ зала"}>
          <span>{l}</span><b>₽{v}</b><i>{l === "ЗДТК" ? "из брони" : "админ зала"}</i>
        </div>
      ))}
      <div className={m.srcl}>Расчёт вписал админ зала{p.entered_by_name ? ` ${p.entered_by_name}` : ""} — поправить может ОО</div>
    </>
  );
}
